module.exports = __webpack_public_path__ + "img/ch1.4c50724f.jpg";